<template>
  <div class="Notice">
    <div class="content">
      <div class="current-loc">
        <span>{{ $t('satellite.CurrentPosition') }}：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>{{ $t('personalCenter.mymessage') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <p class="title">{{ $t('personalCenter.mymessage') }}</p>
      <hr>
      <div class="query">
        <el-button size="mini" type="primary" @click="readMessage">{{
            $t('personalCenter.Allhavebeenread')
          }}
        </el-button>
        <el-button size="mini" @click="deleteMore">{{ $t('Order.Batchdelete') }}</el-button>
      </div>
      <div class="data-table">
        <el-table
            :header-cell-style="header_cell_style_bd"
            :cell-style="cell_style_bd"
            :style="cell_style_bd"
            :data="tableData"
            :empty-text="$t('Intelligent.NoData')"
            ref="MessageTable"
            border>
          <el-table-column
              type="selection"
              align="center"
              width="55">
          </el-table-column>
          <el-table-column
              prop="noticeContent"
              :show-overflow-tooltip="true"
              :label="$t('personalCenter.MessageContent')"
              align="center">
          </el-table-column>
          <el-table-column
              prop="noticeTime"
              :label="$t('personalCenter.Messagepushtime')"
              width="240"
              align="center">
          </el-table-column>
          <el-table-column
              prop="senderName"
              :label="$t('personalCenter.Messagepublisher')"
              width="200"
              align="center">
          </el-table-column>
          <el-table-column
              prop="noticeReadStatus"
              :label="$t('DataSubmission.State')"
              width="200"
              align="center">
            <template slot-scope="scope">
              <span v-if="!isEnglish"
                  :style="{color:(scope.row.noticeReadStatus=='0'?'red':'green')}">{{
                  scope.row.noticeReadStatus == '0' ? '未读' : '已读'
                }}
              </span>
              <span v-else
                  :style="{color:(scope.row.noticeReadStatus=='0'?'red':'green')}">{{
                scope.row.noticeReadStatus == '0' ? 'unread' : 'read'
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
              prop="senderName"
              :label="$t('DataSubmission.Operation')"
              width="200"
              align="center">
            <template slot-scope="scope">
              <span class="delete-detail" @click="viewDetail(scope.row)">{{ $t('satellite.Details') }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
          :title="$t('personalCenter.MessageContent')"
          :visible.sync="newDialog"
          center
          width="25%">
        <div class="down-dialog-main">
          <el-input style="color:black" rows="6" size="mini" type="textarea" disabled resize="none"
                    v-model="noticeContent"></el-input>
        </div>
      </el-dialog>
      <div class="pagenation">
        <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="currentChange"
            :page-size="20">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getUserMsgList,
  readMsg,
  deleteMessage
} from "@/api/message/index"
import {mapGetters} from "vuex";

export default {
  name: 'Notice',
  components: {},
  data() {
    return {
      noticeContent: '',
      currentNotice: '',
      newDialog: false,
      tableData: [],
      total: 0,
      page: {
        limit: 10,
        page: 1
      },
      isEdit: false,
      isEnglish: false,
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['header_cell_style_bd', 'cell_style_bd']),
  },
  created() {
    this.getMessageList()
  },
  methods: {
    async viewDetail(val) {
      let that = this
      that.newDialog = true
      that.noticeContent = val.noticeContent
      let params = {
        pkIds: [val.pkid]
      }
      let res = await readMsg(params)
      that.$store.dispatch('getMessageTotal')
      that.getMessageList()
      console.log(res);
    },
    async deleteMore() {
      let that = this
      const readList = that.$refs.MessageTable.selection
      const allId = readList.map(item => item.pkid)
      let params = {
        pkIds: allId
      }
      let res = await deleteMessage(params)
      if (res.code == '000000') {
        that.$message.success('删除成功！')
        that.getMessageList()
        that.$store.dispatch('getMessageTotal')
      }
      console.log(res);
    },
    async readMessage() {
      let that = this
      const readList = that.$refs.MessageTable.selection
      const allId = readList.map(item => item.pkid)
      let params = {
        pkIds: allId
      }
      let res = await readMsg(params)
      that.getMessageList()
      console.log(res);
      that.$store.dispatch('getMessageTotal')
    },
    async getMessageList() {
      let that = this
      let res = await getUserMsgList(that.page)
      that.tableData = res.data.list
      that.total = parseInt(res.data.totalCount)
      console.log(res);
    },
    currentChange(val) {
      this.page.page = val
      this.getMessageList()
    },
  },
  mounted() {
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
    }
    if (language === 'en') {
      this.isEnglish = true
    }
  }
}
</script>

<style lang="scss" scoped>
hr {
  @include hr_white_to_black();
}

.current-loc {
  height: 21px;
  display: flex;
  align-items: center;

  /deep/ span {
    font-size: 15px;
    @include co_white_to_black();
  }

  /deep/ a {
    @include co_white_to_black();
  }

  /deep/ .el-breadcrumb__item:last-child {
    span {
      color: rgba(38, 125, 255, 1);
    }
  }
}

.Notice {
  width: 100%;
  @include table_page_bg();

  .content {
    min-height: 600px;
    margin: 0 auto;
    padding: 0 12px;
    padding-bottom: 12px;
    .label {
      margin: 60px 0 20px 0;
    }

    .title {
      font-size: 28px;
      color: rgba(39, 121, 202, 1);
      margin: 20px 0;
    }

    .query {
      display: flex;
      align-items: center;
      font-size: 15px;
      margin: 20px 0;

      .search {
        width: 240px;
        margin: 0 12px;
      }

      .search-btn {
      }
    }

    .data-table {
      margin: 20px 0;

      .Notice-status1 {
        width: 8px;
        height: 8px;
        border-radius: 50px;
        background: green;
        margin-right: 8px
      }

      .Notice-status2 {
        @extend .Notice-status1;
        background: rgba(24, 144, 255, 1);
      }

      .Notice-status3 {
        @extend .Notice-status1;
        background: rgba(215, 218, 225, 1);
      }

      .Notice-status {
      }
    }

    .pagenation {
      display: flex;
      justify-content: flex-end;
      padding-right: 0;
    }
  }

  ::v-deep .btn-next {
    margin-right: 0;
  }

  ::v-deep .el-pagination {
    padding-right: 0;
  }
}

.down-dialog-main {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .down-dialog-site {
    margin-bottom: 12px;

    span {
      display: inline-block;
      width: 100px;
      text-align: right;
    }

  }
}
</style>
